import React from 'react';

export interface MemoryEditContextValue {
  memoryID: string;
}

// Create a context with initial value as null
export const MemoryEditContext = React.createContext<
  MemoryEditContextValue | undefined
>(undefined);
